/** Privacy-enhanced host: the embed sets no cookies until the visitor plays. */
const EMBED_HOST = "https://www.youtube-nocookie.com/embed";

/** The 11-character id out of a watch link, a share link or an embed URL. */
const VIDEO_ID =
  /(?:youtu\.be\/|[?&]v=|\/embed\/|\/shorts\/|\/live\/)([\w-]{11})/;

/**
 * Turns a story's `youtubeUrl` into the embed URL the player loads, and answers
 * "is there a clip" for every surface at once: a link nothing can be parsed out
 * of falls back to the still, rather than leaving a play button that opens an
 * empty frame.
 */
export function youtubeEmbedSrc(url?: string): string | undefined {
  const id = url ? VIDEO_ID.exec(url)?.[1] : undefined;
  return id ? `${EMBED_HOST}/${id}` : undefined;
}
